import { render, staticRenderFns } from "./ListOfPromotions.vue?vue&type=template&id=722a2ed4"
import script from "./ListOfPromotions.vue?vue&type=script&lang=js"
export * from "./ListOfPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports